import _ from 'lodash';
import { FilterCondition } from '../../types';
import {
  isDateInputFilter,
  isDateRangeInputFilter,
  isNumberRangeInputFilter,
  isTextInputFilter,
  isTextlessFilter,
} from '../../utils/filter/filterCondition';
import moment from 'moment';

const numError = 'Enter a valid number';
const dateError = 'Enter a valid date';
const textError = 'Value cannot be empty';
const maxNumError = 'Max Number cannot be less than min';
const maxDateError = 'Max Date cannot be less than min';

export const validateFilterConfigs = (
  firstText: string,
  secondText: string,
  condition?: FilterCondition
) => {
  const errors: {
    [key: string]: string;
  } = {};

  const isNumber = (text: string) => {
    return text && !isNaN(Number(text));
  };
  const isDate = (dateString: string) => {
    if (!dateString) return false;
    const dateObject = new Date(dateString);

    return !isNaN(dateObject.getTime());
  };

  const validateBetweenNumbers = () => {
    if (
      !errors.firstText &&
      !errors.secondText &&
      Number(firstText) > Number(secondText)
    ) {
      errors.firstText = maxNumError;
      errors.secondText = maxNumError;
    }
  };
  const validateBetweenDates = () => {
    if (!errors.firstText && !errors.secondText) {
      if (moment(firstText).diff(secondText) > 0) {
        errors.firstText = maxDateError;
        errors.secondText = maxDateError;
      }
    }
  };

  if (condition) {
    switch (true) {
      case isTextlessFilter(condition):
        break;
      case isNumberRangeInputFilter(condition):
        if (!isNumber(firstText)) errors.firstText = numError;
        if (!isNumber(secondText)) errors.secondText = numError;
        validateBetweenNumbers();
        break;
      case isDateRangeInputFilter(condition):
        if (!isDate(firstText)) errors.firstText = dateError;
        if (!isDate(secondText)) errors.secondText = dateError;
        validateBetweenDates();
        break;
      case isDateInputFilter(condition):
        if (!isDate(firstText)) errors.firstText = dateError;
        break;
      case isTextInputFilter(condition):
        if (!firstText.length) errors.firstText = textError;
        break;
      default:
        if (!isNumber(firstText)) errors.firstText = numError;
    }
  }

  return {
    errors,
    isValid: _.isEmpty(errors),
  };
};
